function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Combined_Shape",
  "data-name": "Combined Shape",
  d: "M8,9l.778-.446L15,5v8L8,17ZM0,13V5L2.676,6.524V8.575l1.3.661V7.274L7,9v8ZM5.359,6.424,5,6.209,11.288,2,14,3.791,10.054,6.435,7.713,8ZM1,4.363,7.549,0,10,1.637,3.454,6Z"
});

var SvgIconProduct = function SvgIconProduct(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Product",
    "data-name": "Icon Product",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "#878787",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconProduct, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-product.df548c1b.svg";
export { ForwardRef as ReactComponent };